import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';

/** Short titles for placement / C314 validation and save failures in curriculum dialogs. */
export const PLACEMENT_APP_MSG_TITLE = {
  notReady: 'Not ready',
  invalidSystem: 'Invalid education system',
  cannotSave: 'Cannot save',
  couldNotSave: 'Could not save'
} as const;

export interface AppMessageDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Short heading (e.g. "Cannot save placement"). */
  title: string;
  /** Full message; may be several sentences. */
  message: string;
}

/**
 * In-app replacement for `window.alert`: one primary action, accessible shell, matches app chrome.
 * Use for validation and command failures the user should acknowledge (not toasts).
 */
export function AppMessageDialog({ open, onOpenChange, title, message }: AppMessageDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="whitespace-pre-wrap pt-1">{message}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" onClick={() => onOpenChange(false)}>
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
